export const FILE_SIZE = {
    MAX: 5368709120, // 5GB in bytes
} as const;

export const STRIPE_PAYMENT_STATUS = {
    ACTIVE: 'active',
} as const;

export const ANALYTIC_EVENTS = {
    SCREEN_VIEW: 'screen_view',
} as const;
